

import {useMainStore} from 'stores/main';
import Adverts from 'src/api/adverts';
import {ref, toRef} from 'vue';
import {useQuasar} from 'quasar';
import useAdvertUtils from 'src/components/adverts/utils/useAdvertUtils';

const {extendAdvert} = useAdvertUtils();

export default {
  name: 'DetailEditBar',
  props: {
    advert: {required: true},
  },
  emits: ['updateStatus'],
  setup(props, {emit}) {
    const mainStore = useMainStore()
    const advertProp = toRef(props, 'advert')
    const active = ref(advertProp.value?.active)
    const $q = useQuasar()

    const setStatus = (status) => {
      $q.loading.show({ delay: 200 })
      Adverts.setAdvertStatus(props.advert.uuid, status).then(resp => {
        active.value = resp.data.data.active
        emit('updateStatus', active.value)
      }).finally(() => {
        $q.loading.hide()
      })
    }

    return {
      active,
      setStatus,
      mainStore,
    }
  },
  methods: {extendAdvert}
}
